import React from "react";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import {
  DeleteButton,
  EditButton,
  List,
  ShowButton,
  useDataGrid,
} from "@refinedev/mui";

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const ChallengeList = () => {
  const { dataGridProps } = useDataGrid({});

  const columns = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        flex: 1,
        headerName: "Name",
        minWidth: 180,
        display: "flex",
      },
      {
        field: "type",
        flex: 0.7,
        headerName: "Type",
        minWidth: 120,
        display: "flex",
      },
      {
        field: "actionKey",
        flex: 1,
        headerName: "Action Key",
        minWidth: 180,
        display: "flex",
      },
      {
        field: "targetCount",
        headerName: "Target Count",
        type: "number",
        minWidth: 130,
        display: "flex",
        align: "left",
        headerAlign: "left",
      },
      {
        field: "creditReward",
        headerName: "Credit Reward",
        type: "number",
        minWidth: 130,
        display: "flex",
        align: "left",
        headerAlign: "left",
      },
      {
        field: "isActive",
        headerName: "Active",
        type: "boolean",
        minWidth: 90,
        display: "flex",
      },
      {
        field: "createdAt",
        flex: 1,
        headerName: "Created At",
        minWidth: 180,
        display: "flex",
        valueFormatter: (value) => formatDateTime(value as string | null | undefined),
      },
      {
        field: "updatedAt",
        flex: 1,
        headerName: "Updated At",
        minWidth: 180,
        display: "flex",
        valueFormatter: (value) => formatDateTime(value as string | null | undefined),
      },
      {
        field: "actions",
        headerName: "Actions",
        align: "right",
        headerAlign: "right",
        minWidth: 120,
        sortable: false,
        display: "flex",
        renderCell: ({ row }) => {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
              <DeleteButton hideText recordItemId={row.id} />
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid {...(dataGridProps as any)} columns={columns as any} />
    </List>
  );
};

